// 黃底 160px的按鈕
export const btnMainStyleEnable = (text: String = 'Text', disable: boolean = false) => {
    return {
        text: text,
        disable: disable,
        theme: '1',
        color: 'main2-gradient',
        type: 'full',
        wd: 'smd'
    }
}
// border 160px的按鈕
export const btnBorderMainStyleEnable = (text: String = 'Text', disable: boolean = false) => {
    return {
        text: text,
        disable: disable,
        theme: '1',
        color: 'main',
        type: 'border',
        wd: 'smd'
    }
}

// full main 100%
export const btnMainStyleFull = (text: String = 'Text', disable: boolean = false) => {
    return {
        text: text,
        disable: disable,
        theme: '1',
        color: 'main2-gradient',
        type: 'full',
        wd: 'full'
    }
}

// border main 100%
export const btnBorderMainStyleFull = (text: String = 'Text', disable: boolean = false) => {
    return {
        text: text,
        disable: disable,
        theme: '1',
        color: 'main',
        type: 'border',
        wd: 'full'
    }
}
// border main 100%
export const btnDefault = (text: String = 'Text', disable: boolean = false) => {
    return {
        text: text,
        disable: disable,
        theme: '2',
        color: 'transprent',
        type: 'full',
        wd: 'auto'
    }
}

